import MyPage from "../Pages/MyPage";

const MyPageRoutes = () => {
  return <>
    <MyPage /></>;
};

export default MyPageRoutes;
